import { Outreach } from './Outreach';

export default Outreach;
